export default "__VITE_ASSET__I8_wzELn__"